import React, { useEffect, useRef } from 'react';
import './index.css';
import { widget } from '../../charting_library';
import Datafeed from '../../mydatafeed/datafeed_price_feed';

function getLanguageFromURL() {
    const regex = new RegExp('[\\?&]lang=([^&#]*)');
    const results = regex.exec(window.location.search);
    return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

let disabledFeatures = ['use_localstorage_for_settings', 'header_saveload', 'left_toolbar', 'header_widget', 'timeframes_toolbar'];

const supported_resolutions = ['1', '5', '30', '1H']

export const TVChartContainerPriceMonitor = () => {
    const chartContainerRef = useRef();

    const defaultProps = {
        symbol: 'USDCLP',
        interval: '1',
        libraryPath: '/charting_library/',
        fullscreen: false,
        autosize: true,
    };

    useEffect(() => {
        const widgetOptions = {
            symbol: defaultProps.symbol,
            datafeed: Datafeed,
            interval: defaultProps.interval,
            container: chartContainerRef.current,
            library_path: defaultProps.libraryPath,
            theme: "dark",
            style: "3", // Area/Line
            timezone: "America/Santiago",
            locale: getLanguageFromURL() || 'en',
            disabled_features: disabledFeatures,
            fullscreen: defaultProps.fullscreen,
            autosize: defaultProps.autosize,
            height: '100%',
            width: '100%',
            supported_resolutions: supported_resolutions,
        };

        const tvWidget = new widget(widgetOptions);

        tvWidget.onChartReady(() => {
            tvWidget.applyOverrides({
                "mainSeriesProperties.style": 3,
                "mainSeriesProperties.areaStyle.linecolor": "#40BFB1",
                "mainSeriesProperties.areaStyle.color1": "rgba(64, 191, 177, 0.2)",
                "mainSeriesProperties.areaStyle.color2": "rgba(64, 191, 177, 0.0)"
            });
            tvWidget.setAutoScale(true);
        });

        return () => {
            if (tvWidget !== null) {
                tvWidget.remove();
            }
        };
    }, []);

    return (
        <div ref={chartContainerRef} style={{ height: '100%', width: '100%' }} />
    );

}
